<template>
  <el-dialog :visible.sync="show" :title="name" width="900px">
    <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
      <el-form-item prop="userName" label="用户名" v-if="!isSubscribe">
        <el-input v-model="data.userName" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item prop="userPhone" label="手机号" v-if="!isSubscribe">
        <el-input v-model="data.userPhone" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item prop="state" label="是否订阅">
        <el-select v-model="data.state" placeholder="选择是或否" style="width: 100%;" :disabled="isSubscribe">
          <el-option v-for="(item, index) in stateList" :value="item.value" :label="item.label"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="dayNumber" label="订阅天数" v-if="data.state === 'Subscribe'">
        <el-input-number v-model="data.dayNumber" :min="1" :max="1000" :step="1" style="width: 100%;"
          @change="changeDayNumber"></el-input-number>
        <el-radio-group v-model="data.dayNumber" @change="changeDayNumber">
          <el-radio :label="7">7天</el-radio>
          <el-radio :label="30">30天</el-radio>
          <el-radio :label="60">60天</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="subscribeStartTime" label="开始时间" v-if="data.state === 'Subscribe'">
        <el-date-picker v-model="data.subscribeStartTime" type="datetime" placeholder="选择开始时间" clearable
          style="width: 100%" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item prop="subscribeEndTime" label="结束时间" v-if="data.state === 'Subscribe'">
        <el-date-picker v-model="data.subscribeEndTime" type="datetime" placeholder="选择结束时间" clearable
          style="width: 100%" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item prop="freeTrialTimes" label="剩余体验次数" v-if="!isSubscribe">
        <el-input-number v-model="data.freeTrialTimes" :min="0" :step="1" style="width: 100%;"></el-input-number>
      </el-form-item>
      <el-form-item prop="remark" label="备注" v-if="!isSubscribe">
        <el-input v-model="data.remark" placeholder="输入备注" type="text"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import XEUtils from 'xe-utils'

export default {
  data() {
    return {
      show: false,
      name: '',
      data: {},
      rules: {
        userPhone: [{ required: true, trigger: 'change', message: '输入手机号' }],
        subscribeStartTime: [{ required: true, trigger: 'change', message: '选择开始时间' }],
        subscribeEndTime: [{ required: true, trigger: 'change', message: '选择结束时间' }],
        state: [{ required: true, trigger: 'change', message: '选择是或否' }]
      },
      loading: false,
      stateList: [
        { value: 'Subscribe', label: '是' },
        { value: 'NotSubscribe', label: '否' }
      ],
      isSubscribe: false
    }
  },
  methods: {
    display(e) {
      this.data = XEUtils.clone(e.data, true)
      this.name = e.name
      this.isSubscribe = e.isSubscribe || false
      this.changeDayNumber()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate(this.data)
        }
      })
      this.show = true
    },
    changeDayNumber() {
      if (this.data.dayNumber) {
        this.$set(this.data, 'subscribeStartTime', XEUtils.toDateString(new Date(), 'yyyy-MM-dd HH:mm:ss'))
        this.$set(this.data, 'subscribeEndTime', XEUtils.toDateString(XEUtils.getWhatDay(this.data.subscribeStartTime, this.data.dayNumber), 'yyyy-MM-dd HH:mm:ss'))
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate(this.data)
          }
        })
      }
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = JSON.parse(JSON.stringify(this.data))
          this.$axios.post('/account/user/subscription/manager/update', params).then(() => {
            this.$message.success({ showClose: true, message: `${this.name}成功` })
            this.show = false
            this.$emit('init')
            this.loading = false
          }).catch(err => {
            console.log(`${this.name}失败`, err)
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style>
.el-radio__original {
  display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
</style>
